/* Dialog Text */
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import {
  InteractSubType,
  InteractSubLevel,
  XmlaSubscriptionTypeEx,
  XmlaSubscriptionLevelEx,
  ReportSubscriptionType,
  ReportSubscriptionLevel,
  ReportSubscriptionLevelEx,
} from "../../../api/models";

export interface EditCouponLevelDialogData {
  dialogTitle: string;
  isNew: boolean;
  couponCode: string;
  interactSubscriptionTypeId?: number;
  interactSubscriptionLevelId?: number;
  reportSubscriptionTypeId?: number;
  reportSubscriptionLevelId?: number;
  interactSubscriptionTypes: InteractSubType[];
  interactSubscriptionLevels: InteractSubLevel[];
  reportSubscriptionTypes: ReportSubscriptionType[];
  reportSubscriptionLevels: ReportSubscriptionLevelEx[];
}

@Component({
  selector: "edit-coupon-level-dialog",
  styleUrls: ["edit-coupon-level-dialog.component.css"],
  templateUrl: "./edit-coupon-level-dialog.component.html",
})
export class EditCouponLevelDialogComponent {
  public Result: DialogResult;
  public LevelType: string = "Interactive";
  public filteredSubLevels: InteractSubLevel[];
  public filteredReportSubscriptionLevels: ReportSubscriptionLevelEx[];

  constructor(
    public dialogRef: MatDialogRef<EditCouponLevelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditCouponLevelDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    if (this.LevelType == "Interactive") {
      this.data.reportSubscriptionTypeId = null;
      this.data.reportSubscriptionLevelId = null;
    } else if (this.LevelType == "Report") {
      this.data.interactSubscriptionTypeId = null;
      this.data.interactSubscriptionLevelId = null;
    }
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }

  updateInteractiveType() {
    this.filteredSubLevels = [];
    for (var i = 0; i < this.data.interactSubscriptionLevels.length; i++) {
      if (
        this.data.interactSubscriptionLevels[i].interactSubTypeId ==
        this.data.interactSubscriptionTypeId
      ) {
        this.filteredSubLevels.push(this.data.interactSubscriptionLevels[i]);
      }
    }
  }

  updateReportType() {
    this.filteredReportSubscriptionLevels = [];
    for (var i = 0; i < this.data.reportSubscriptionLevels.length; i++) {
      if ( this.data.reportSubscriptionLevels[i].reportSubscriptionTypeId == this.data.reportSubscriptionTypeId) {
        this.filteredReportSubscriptionLevels.push(this.data.reportSubscriptionLevels[i]);
      }
    }
  }
}

/* Calling Methods */
/*
  callEditCouponLevels(params: EditCouponLevelsDialogData) {
    var dialogRef = this.dialog.open(EditCouponLevelsDialogComponent, {
      width: '500px',
      data: params
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
        //Do something here!
      }
    });
  }
*/
